// @ts-nocheck
/* eslint-disable */ /* NOTE: Auto-generated. Run `yarn build-icons` instead of editing. */ import { ReactComponent as DotsHorizontalDefault } from '../../../../../ui-v3/src/assets/icons/default/general/dots-horizontal.svg?react';
import { ReactComponent as DotsHorizontalSolid } from '../../../../../ui-v3/src/assets/icons/solid/general/DOTS-HORIZONTAL.svg?react';
import { createIcons } from '../../Icon';
const DotsHorizontalIcon = /* @__PURE__ */ createIcons('DotsHorizontal', {
    default: DotsHorizontalDefault,
    solid: DotsHorizontalSolid
});
DotsHorizontalIcon.supportedTypes = [
    'default',
    'solid'
];
DotsHorizontalIcon.category = 'general';
export default DotsHorizontalIcon;
